module.exports = __webpack_public_path__ + "static/media/Snootie-Studios.d4fd83f5.jpg";